<template>
  <main>
    <section id="info-section" v-if="!storeQuiz.getOpen && loaderStore.load[1]">
      <ModalPermissionBrowser />
      <SpeechRecognition v-if="hasSpeechRecognition()" />
    </section>
    <Loader v-if="loaderStore.load[1]" :loader="loaderStore.load[1]" />
    <section v-else class="grid grid-cols-12 gap-5 p-10 h-full">
      <div id="material" class="col-span-12 sm:col-span-12 lg:col-span-9">
        <Material v-if="storeMaterial.currentMaterial?.id" />
        <div id="empty" v-else class="h-[80vh]">
          <EmptyData
            :data="!storeMaterial.currentMaterial"
            :title="`${$t('studentCourse.empty.materialBeingWatch.title')}`"
            :label="`${$t(
              'studentCourse.empty.materialBeingWatch.description'
            )}`"
            :image="'empty-materials-watch.svg'"
            imgSize="h-40"
          />
        </div>
      </div>

      <div
        id="sidebar"
        class="col-span-12 sm:col-span-12 lg:col-span-3 flex flex-col justify-center items-center bg-white rounded-lg"
      >
        <ProgressCard />
        <div class="bg-neutral-200 h-[1px] mb-8 w-11/12 hidden lg:flex"></div>
        <Sidebar />
      </div>

      <div v-if="storeQuiz.getOpen" id="quiz">
        <QuizStudent
          @onProceed="storeQuiz.proceedQuiz"
          @onEnded="storeQuiz.quizEnded"
          @onClose="storeQuiz.closeQuiz"
          :quiz="storeQuiz.quizData"
          :quizIntro="storeQuiz.quizIntro.quizTO"
          :quizEnded="storeQuiz.getQuizHasEnded"
          :learningName="storeChapter.currentChapter?.name"
          :isAdaptative="false"
        />
      </div>

      <Chat
        @onBackMaterial="storeNavigation.prev"
        @onCheckVideoEnded="storeNavigation.next"
        :indexMaterial="storeMaterial.currentMaterialIndex"
        :user="user"
        :msgType="'default'"
        :hSize="`!h-[90vh]`"
        :currentMaterial="storeMaterial.currentMaterial!"
        class="custom-chat"
        ref="chat"
      />
    </section>
  </main>
</template>

<script lang="ts">
import { useChapterStore } from "@/store/linear/chapter";
import { ELoader, useLoaderStore } from "@/store/linear/loader";
import { useMaterialStore } from "@/store/linear/material";
import { useNavigationStore } from "@/store/linear/navigation";
import { useQuizStore } from "@/store/linear/quiz";
import { useTrailStore } from "@/store/linear/trail";
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineAsyncComponent, defineComponent, ref, watch } from "vue";

const Sidebar = defineAsyncComponent(() => import("./Sidebar/index.vue"));
const ProgressCard = defineAsyncComponent(
  () => import("./percentage-card.vue")
);

const Material = defineAsyncComponent(() => import("./material.vue"));
const QuizStudent = defineAsyncComponent(
  () => import("@/views/Quiz/Student/quiz-student.vue")
);

const Chat = defineAsyncComponent(
  () => import("@/components/ChatBot/Chat/chat.vue")
);

export default defineComponent({
  name: "TraditionalContent",
  components: { Sidebar, Material, QuizStudent, ProgressCard, Chat },
  setup() {
    const storeChapter = useChapterStore;
    const storeMaterial = useMaterialStore;
    const storeNavigation = useNavigationStore;
    const storeTrail = useTrailStore;
    const storeQuiz = useQuizStore;
    const loaderStore = useLoaderStore;
    const showQuiz = ref(false);
    const quizHasEnded = ref(false);

    watch(storeQuiz, (val) => storeQuiz.setOpen(val.getOpen));

    return {
      storeChapter,
      storeTrail,
      storeMaterial,
      storeNavigation,
      loaderStore,
      storeQuiz,
      showQuiz,
      quizHasEnded,
      user: getUserFromStorage(),
    };
  },
  mounted() {
    this.loaderStore.start(ELoader.CHAPTERS);
    this.getTraditionalCourseById();
  },
  unmounted() {
    this.storeChapter.$reset();
    this.storeQuiz.$reset();
    this.storeMaterial.$reset();
    this.storeTrail.$reset();
  },
  methods: {
    getTraditionalCourseById(): void {
      this.storeChapter.getCourse();
    },
    proceedQuiz(type: string): void {
      if (type === "proceed") this.closeQuiz();
    },
    closeQuiz(): void {
      this.showQuiz = false;
      this.quizHasEnded = false;
    },
    hasSpeechRecognition(): boolean {
      let result = false;
      if ("webkitSpeechRecognition" in window) result = true;
      return result;
    },
  },
});
</script>

<style lang="scss">
.chat-bot {
  @apply shadow-md  border-2 fixed right-0 md:max-w-[32rem] min-w-[300px] w-[100vw] #{!important};
}
</style>
